import { Injectable } from '@angular/core';
import { PaintGroup } from '../interfaces/paint-group';

@Injectable({
  providedIn: 'root',
})
export class PaintGroupManager {
  /** is the painting group allowed to have duplicate indexes added */
  allowDuplicates: boolean = false;

  /** current group being painted */
  paintingGroup?: PaintGroup;

  private _createPaintGroup(groupId: number, threeByThree: boolean = false) {
    this.paintingGroup = {
      indexes: [],
      groupId: groupId,
      is3x3: threeByThree,
    };
  }

  private _addIndex(index: number) {
    if (this.allowDuplicates || !this.paintingGroup?.indexes.includes(index)) {
      this.paintingGroup?.indexes.push(index);
    }
  }

  pointerDownEvent(index: number, threeByThree: boolean = false) {
    this._createPaintGroup(0, threeByThree);
    this._addIndex(index);
  }

  pointerUpEvent(): PaintGroup | null {
    return this.paintingGroup && this.paintingGroup?.indexes.length > 0 ? this.paintingGroup : null;
  }

  pointerMoveEvent(index: number) {
    this._addIndex(index);
  }
}
